<script setup lang="ts">
import type { QuickFilterGroup } from "~/core/models/QuickFilterGroup.interface";
import type { QuickFilterItem } from "~/core/models/QuickFilterItem.interface";

defineProps<{
  groups: QuickFilterGroup[];
}>();

const emit = defineEmits(["filter-click"]);

function onFilterClick(group: QuickFilterGroup, item: QuickFilterItem) {
  emit("filter-click", { group, item });
}
</script>

<template>
  <div v-if="groups.length > 0" class="flex flex-col gap-4">
    <div v-for="group in groups" :key="group.key" class="flex flex-wrap gap-2">
      <lxc-button
        v-for="item in group.items"
        :key="item.key"
        :title="item.label"
        :type="item.isActive ? 'primary' : 'secondary'"
        :icon="item.icon"
        :icon-class="item.iconClass"
        class="!text-sm !py-[0.438rem] !px-3.5"
        html-type="button"
        @click="onFilterClick(group, item)"
      >
        {{ item.label }}
      </lxc-button>
    </div>
  </div>
</template>
